import { render } from "./VehicleAccessControl.vue?vue&type=template&id=094ead5a&scoped=true"
import script from "./VehicleAccessControl.vue?vue&type=script&lang=js"
export * from "./VehicleAccessControl.vue?vue&type=script&lang=js"

import "./VehicleAccessControl.vue?vue&type=style&index=0&id=094ead5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094ead5a"]])

export default __exports__